import React from 'react';
import { Button, Dialog } from '@economic/taco';
import { Trans } from '@lingui/macro';

import { t } from '../../../../shared/components/l10n/l10n';
import MoneyflowOnboardDialogFooter from '../../../sales/invoicing/invoices/book-and-send/moneyflow/always-on-version/MoneyflowOnboardDialogFooter';
import moneyflowOnboardingError from './moneyflow-onboarding-error.svg';
import ExternalLink from '../../../../shared/components/ExternalLink';

interface Props {
    onClose?: () => void;
}

export default function StepOnboard({ onClose }: Props) {
    return (
        <>
            <Dialog.Title>
                <Trans>Sorry, we can't offer this service at this time.</Trans>
            </Dialog.Title>
            <div className="flex mt-12">
                <div className="flex flex-col">
                    <strong>
                        <Trans>Something went wrong</Trans>
                    </strong>
                    <p>
                        <Trans>An unknown error has occured, we were not able to complete your onboarding to Moneyflow.</Trans>
                    </p>
                    <strong>
                        <Trans>We are always here to help</Trans>
                    </strong>
                    <p>
                        <Trans>
                            Please contact <ExternalLink href={t`https://moneyflow.io`}>Moneyflow</ExternalLink>'s support team to
                            help you continue at this time.
                        </Trans>
                    </p>
                    <div className="flex flex-col">
                        <span>
                            <Trans>Email:</Trans>
                        </span>
                        <span>
                            <a href={`mailto:${(<Trans>support@moneyflow.io</Trans>)}`} className="text-xs pb-1">
                                <Trans>support@moneyflow.io</Trans>
                            </a>
                        </span>
                    </div>
                    <div className="flex flex-col mt-4">
                        <span>
                            <Trans>Telephone:</Trans>
                        </span>
                        <span>
                            <Trans>+45 89 87 70 36</Trans>
                        </span>
                    </div>
                </div>
                <img src={moneyflowOnboardingError} />
            </div>
            {onClose !== undefined && (
                <div className="flex justify-end mt-20">
                    <Button appearance="primary" onClick={onClose}>
                        <Trans>Close</Trans>
                    </Button>
                </div>
            )}

            <MoneyflowOnboardDialogFooter />
        </>
    );
}
